import { render, staticRenderFns } from "./IngredientGroupCreate.vue?vue&type=template&id=3b315068&scoped=true"
import script from "./IngredientGroupCreate.vue?vue&type=script&lang=js"
export * from "./IngredientGroupCreate.vue?vue&type=script&lang=js"
import style0 from "./IngredientGroupCreate.vue?vue&type=style&index=0&id=3b315068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b315068",
  null
  
)

export default component.exports